import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"
import { modalStyles } from "../../../utilities/Constants"

const AppBtn = ({
	title,
	styleName,
	onClick,
	disabled = false,
	// `loading` : grise le bouton + remplace le libellé par un sync animé pendant
	// une opération asynchrone (sauvegarde…).
	loading = false,
}) => {
	const isDisabled = disabled || loading
	const getStyle = () => {
		if (isDisabled) return modalStyles.btnDisabled
		switch (styleName) {
			case "primary":
				return modalStyles.btnPrimary
			case "secondary":
				return modalStyles.btnSecondary
			case "danger":
				return modalStyles.btnDanger
			default:
				return modalStyles.btnSecondary
		}
	}
	return (
		<button style={getStyle()} onClick={onClick} disabled={isDisabled}>
			{loading ? <FontAwesomeIcon icon={faSync} spin /> : title}
		</button>
	)
}

export default AppBtn
